import { inject, PLATFORM_ID, provideAppInitializer } from '@angular/core';
import {
  CORE_APP_ENV,
  CORE_APP_NAME,
  CORE_APP_VERSION,
  CORE_DEBUG,
  CORE_FEATURE_TOGGLE,
  CORE_STARTUP_DATE,
  CORE_STARTUP_ID,
} from './core.tokens';
import {
  CallWaiterService,
  ClusterService,
  DeviceBrightness,
  DeviceWorkScheduleService,
  HappyHoursService,
  Intercom,
  InvoiceQrcodeImageService,
  MenusService,
  NetworkService,
  RestaurantAppService,
  RestaurantTableService,
  SpecialsService,
  UpdateService,
  WatchdogService,
  WebsocketService,
} from './lib/services';

export const provideCoreInitialize = () => provideAppInitializer(() => {
  const id = inject(CORE_STARTUP_ID);
  const date = inject(CORE_STARTUP_DATE);
  const name = inject(CORE_APP_NAME);
  const version = inject(CORE_APP_VERSION);
  const environment = inject(CORE_APP_ENV);
  const debug = inject(CORE_DEBUG);
  const featureToggle = inject(CORE_FEATURE_TOGGLE);
  const platformId = inject(PLATFORM_ID);
  const update = inject(UpdateService);
  const cluster = inject(ClusterService);
  const network = inject(NetworkService);
  const intercom = inject(Intercom);
  const websocket = inject(WebsocketService);
  const watchdog = inject(WatchdogService);
  const restaurantApp = inject(RestaurantAppService);
  const restaurantTable = inject(RestaurantTableService);
  const callWaiter = inject(CallWaiterService);
  const deviceWorkSchedule = inject(DeviceWorkScheduleService);
  const brightnessSettings = inject(DeviceBrightness);
  const specials = inject(SpecialsService);
  const menu = inject(MenusService);
  const happyHours = inject(HappyHoursService);
  const invoiceQrcode = inject(InvoiceQrcodeImageService);

  const log = watchdog.tag('App', 'red');

  log.info('Initializing', {
    id,
    date,
    name,
    version,
    environment,
    debug,
    featureToggle,
    platform: platformId,
  });

  update.initialize();
  cluster.initialize();
  intercom.initialize();
  websocket.initialize();
  network.initialize();
  deviceWorkSchedule.initialize();
  brightnessSettings.initialize();
  restaurantApp.initialize();
  restaurantTable.initialize();
  callWaiter.initialize();
  menu.initialize();
  happyHours.initialize();
  specials.initialize();
  invoiceQrcode.initialize();
});
